export const getWebHIDSupportStatus = () => typeof navigator.hid === 'object';
